import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { firstValueFrom } from "rxjs";
import { environment } from "../../../../Environments/Environment";
import { DashboardFulfillmentFunnelResponse } from "../Dto/DashboardFulfillmentFunnelResponse";
import { DashboardOverviewResponse, DashboardPeriod } from "../Dto/DashboardOverviewResponse";

@Injectable({ providedIn: "root" })
export class DashboardApi {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = environment.adminServiceUrl;

  async getOverview(period: DashboardPeriod): Promise<DashboardOverviewResponse> {
    const url = new URL("dashboard/overview", `${this.baseUrl}/`);
    url.search = new URLSearchParams({ period }).toString();

    return await firstValueFrom(this.http.get<DashboardOverviewResponse>(url.toString(), { withCredentials: true }));
  }

  async getFulfillmentFunnel(period: DashboardPeriod): Promise<DashboardFulfillmentFunnelResponse> {
    const url = new URL("dashboard/fulfillment-funnel", `${this.baseUrl}/`);
    url.search = new URLSearchParams({ period }).toString();

    return await firstValueFrom(this.http.get<DashboardFulfillmentFunnelResponse>(url.toString(), { withCredentials: true }));
  }
}
